/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "skills";

export interface SendMotionCommandActionArgs {
  /**
   * Encoded motion command message. The command will be published with the SKILLS sender ID.
   * We don't use the MotionCommand type directly because we don't want to make it part of the
   * missions API just yet, as this would prevent us from making breaking changes to the type during
   * development. Once the type is stable, we probably should deprecate this field and replace it
   * with an actual MotionCommand.
   */
  encodedMotionCommand: Uint8Array;
  /** Keep publishing the motion command for this amount of time. */
  durationS: number;
}

export interface SendMotionCommandResultData {
}

export interface SendMotionCommandActionStateData {
}

function createBaseSendMotionCommandActionArgs(): SendMotionCommandActionArgs {
  return { encodedMotionCommand: new Uint8Array(0), durationS: 0 };
}

export const SendMotionCommandActionArgs = {
  encode(message: SendMotionCommandActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.encodedMotionCommand.length !== 0) {
      writer.uint32(10).bytes(message.encodedMotionCommand);
    }
    if (message.durationS !== 0) {
      writer.uint32(21).float(message.durationS);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SendMotionCommandActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSendMotionCommandActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.encodedMotionCommand = reader.bytes();
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.durationS = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SendMotionCommandActionArgs {
    return {
      encodedMotionCommand: isSet(object.encodedMotionCommand)
        ? bytesFromBase64(object.encodedMotionCommand)
        : new Uint8Array(0),
      durationS: isSet(object.durationS) ? globalThis.Number(object.durationS) : 0,
    };
  },

  toJSON(message: SendMotionCommandActionArgs): unknown {
    const obj: any = {};
    if (message.encodedMotionCommand.length !== 0) {
      obj.encodedMotionCommand = base64FromBytes(message.encodedMotionCommand);
    }
    if (message.durationS !== 0) {
      obj.durationS = message.durationS;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SendMotionCommandActionArgs>, I>>(base?: I): SendMotionCommandActionArgs {
    return SendMotionCommandActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SendMotionCommandActionArgs>, I>>(object: I): SendMotionCommandActionArgs {
    const message = createBaseSendMotionCommandActionArgs();
    message.encodedMotionCommand = object.encodedMotionCommand ?? new Uint8Array(0);
    message.durationS = object.durationS ?? 0;
    return message;
  },
};

function createBaseSendMotionCommandResultData(): SendMotionCommandResultData {
  return {};
}

export const SendMotionCommandResultData = {
  encode(_: SendMotionCommandResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SendMotionCommandResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSendMotionCommandResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SendMotionCommandResultData {
    return {};
  },

  toJSON(_: SendMotionCommandResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SendMotionCommandResultData>, I>>(base?: I): SendMotionCommandResultData {
    return SendMotionCommandResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SendMotionCommandResultData>, I>>(_: I): SendMotionCommandResultData {
    const message = createBaseSendMotionCommandResultData();
    return message;
  },
};

function createBaseSendMotionCommandActionStateData(): SendMotionCommandActionStateData {
  return {};
}

export const SendMotionCommandActionStateData = {
  encode(_: SendMotionCommandActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SendMotionCommandActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSendMotionCommandActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SendMotionCommandActionStateData {
    return {};
  },

  toJSON(_: SendMotionCommandActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SendMotionCommandActionStateData>, I>>(
    base?: I,
  ): SendMotionCommandActionStateData {
    return SendMotionCommandActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SendMotionCommandActionStateData>, I>>(
    _: I,
  ): SendMotionCommandActionStateData {
    const message = createBaseSendMotionCommandActionStateData();
    return message;
  },
};

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return globalThis.Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
